import { FormOptionItem } from '@/models/form';

export enum ServiceTypes {
  LAND = 'land',
  RESERVATION = 'reservation',
  REPAIR = 'repair',
  OTHER = 'other',
}

export enum ServiceCode {
  LAND = 1,
  RESERVATION = 2,
  REPAIR = 3,
  OTHER = 4,
}

export enum ServiceName {
  LAND = '土地開發',
  RESERVATION = '預約賞屋',
  REPAIR = '住戶報修',
  OTHER = '其他',
}

export interface ServiceTypeOption {
  code: ServiceCode;
  label: string;
  slug: ServiceTypes;
}

export const serviceTypeList = [
  ServiceTypes.LAND, ServiceTypes.RESERVATION, ServiceTypes.REPAIR, ServiceTypes.OTHER,
];

export const serviceTypeOptions: ServiceTypeOption[] = [
  {
    code: ServiceCode.LAND,
    label: ServiceName.LAND,
    slug: ServiceTypes.LAND,
  },
  {
    code: ServiceCode.RESERVATION,
    label: ServiceName.RESERVATION,
    slug: ServiceTypes.RESERVATION,
  },
  {
    code: ServiceCode.REPAIR,
    label: ServiceName.REPAIR,
    slug: ServiceTypes.REPAIR,
  },
  {
    code: ServiceCode.OTHER,
    label: ServiceName.OTHER,
    slug: ServiceTypes.OTHER,
  },
];

export enum ServiceFormStatusTypes {
  UNREAD = 'unread',
  READED = 'readed',
  RESOLVED = 'resolved',
  CLOSED = 'closed',
}

export interface ServiceFormStatusOption {
  code: ServiceFormStatusTypes;
  label: string;
}

export const serviceFormStatusList = [
  ServiceFormStatusTypes.CLOSED,
  ServiceFormStatusTypes.READED,
  ServiceFormStatusTypes.RESOLVED,
  ServiceFormStatusTypes.UNREAD,
];

export const serviceFormStatusOptions: ServiceFormStatusOption[] = [
  {
    code: ServiceFormStatusTypes.UNREAD,
    label: '未讀取',
  },
  {
    code: ServiceFormStatusTypes.READED,
    label: '已讀取',
  },
  // {
  //   code: ServiceFormStatusTypes.CLOSED,
  //   label: '已關閉',
  // },
  {
    code: ServiceFormStatusTypes.RESOLVED,
    label: '已完成',
  },
];

/*
 * 1 -> 全天皆可
 * 2 -> 白天皆可
 * 3 -> 上午9 : 00 – 12 : 00
 * 4 -> 中午12 : 00 – 14 : 00
 * 5 -> 下午14 : 00 – 18 : 00
 * 6 -> 晚上18 : 00 – 21 : 00
 */
export enum EServiceSessionTimeCode {
  ALL = 1,
  DAYTIME = 2,
  MORNING = 3,
  NOON = 4,
  AFTERNOON = 5,
  NIGHT = 6,
}

export enum EServiceSessionTimeName {
  ALL = '全天皆可',
  DAYTIME = '白天皆可',
  MORNING = '上午 (9:00 – 12:00)',
  NOON = '中午 (12:00 – 14:00)',
  AFTERNOON = '下午 (14:00 – 18:00)',
  NIGHT = '晚上 (18:00 – 21:00)',
}

export const serviceTimeOptions: FormOptionItem[] = [
  { name: EServiceSessionTimeName.ALL, value: EServiceSessionTimeCode.ALL },
  {
    name: EServiceSessionTimeName.DAYTIME,
    value: EServiceSessionTimeCode.DAYTIME,
  },
  {
    name: EServiceSessionTimeName.MORNING,
    value: EServiceSessionTimeCode.MORNING,
  },
  { name: EServiceSessionTimeName.NOON, value: EServiceSessionTimeCode.NOON },
  {
    name: EServiceSessionTimeName.AFTERNOON,
    value: EServiceSessionTimeCode.AFTERNOON,
  },
  { name: EServiceSessionTimeName.NIGHT, value: EServiceSessionTimeCode.NIGHT },
];
